import { useState, Fragment } from "react";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@/components/ui/input-otp";
import { Button } from "@/components/ui/button";
import { philosopher } from "@/lib/fonts";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

interface VerifyOtpProps {
  email: string;
  onSubmit: (otp: string) => void;
  onResentOtp: () => void;
  onBack: () => void;
  length: number;
  separateAfter?: number;
  showBack?: boolean;
}

function VerifyOtp({
  email,
  onSubmit,
  onResentOtp,
  onBack,
  length,
  separateAfter = 0,
  showBack = false,
}: VerifyOtpProps) {
  const [otp, setOtp] = useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (otp.length !== length) {
      toast.error(`OTP must be ${length} characters long`);
      return;
    }
    onSubmit(otp);
  };

  return (
    <div className="flex items-center justify-center px-4 pt-4">
      <div className="w-full flex flex-col items-center justify-center space-y-6">
        <div className="text-center space-y-2">
          <h1 className={`text-3xl font-semibold ${philosopher.className}`}>
            <span>Verify</span>&nbsp;
            <span className="text-primary">Email</span>
          </h1>
          <p className="text-muted">
            Please enter the code just sent to your email{" "}
            <span className="text-primary">{email}</span>
          </p>
        </div>
        {/* <Form {...form}> */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex justify-center">
            {/* <Controller
                name="otp"
                control={form.control}
                render={({ field }) => ( */}
            <InputOTP
              maxLength={length}
              // value={field.value}
              onChange={setOtp}
            >
              {separateAfter > 0
                ? Array.from({
                    length: Math.ceil(length / separateAfter),
                  }).map((_, groupIdx) => {
                    const start = groupIdx * separateAfter;
                    const end = Math.min(start + separateAfter, length);
                    return (
                      <Fragment key={groupIdx}>
                        <span className="flex items-center">
                          <InputOTPGroup>
                            {Array.from({ length: end - start }).map(
                              (__, slotIdx) => (
                                <InputOTPSlot
                                  key={start + slotIdx}
                                  index={start + slotIdx}
                                />
                              ),
                            )}
                          </InputOTPGroup>
                        </span>
                        {end < length && <InputOTPSeparator />}
                      </Fragment>
                    );
                  })
                : Array.from({ length }).map((_, idx) => (
                    <InputOTPGroup key={idx}>
                      <InputOTPSlot index={idx} />
                    </InputOTPGroup>
                  ))}
            </InputOTP>
            {/* )}
              /> */}
          </div>
          <Button
            type="submit"
            className="w-full rounded-full bg-primary py-6 text-lg"
          >
            Verify
          </Button>
        </form>
        {/* </Form> */}
        <p className="text-center text-sm">
          Didn’t receive OTP? <br />
          <span className="text-primary underline" onClick={onResentOtp}>
            Resend OTP
          </span>
        </p>
        {showBack && (
          <div className="p-1 bg-white rounded-full border">
            <ArrowLeft className="w-6 h-6 cursor-pointer" onClick={onBack} />
          </div>
        )}
      </div>
    </div>
  );
}

export default VerifyOtp;
